module.exports = __webpack_public_path__ + "static/media/Tennis.92093d0e.svg";